import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { RoomSortKey, RoomSortKeyValues } from '@/constants/cleaning-manager'

interface SortSheetProps {
  sortKey: RoomSortKey
  onSelect: (sortKey: RoomSortKey) => void
  onClose: () => void
}

export const SortSheet: React.FC<SortSheetProps> = ({ sortKey, onSelect, onClose }) => {
  const { t } = useTranslation()

  return (
    <div css={overlayStyle} onClick={onClose}>
      <div css={sheetStyle} onClick={e => e.stopPropagation()}>
        <div className="grabber">
          <span />
        </div>
        <p className="title">{t('cleaningManager.SortOrder')}</p>
        <ul>
          {Object.values(RoomSortKey).map(key => {
            const isSelected = key === sortKey
            return (
              <li key={key}>
                <button type="button" className={isSelected ? 'selected' : ''} aria-pressed={isSelected} onClick={() => onSelect(key)}>
                  <span className="label">{t(RoomSortKeyValues[key])}</span>
                  <span className="radio">{isSelected && <span className="dot" />}</span>
                </button>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

const overlayStyle = css({
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.38)',
  zIndex: 300,
  display: 'flex',
  alignItems: 'flex-end',
})

const sheetStyle = css({
  width: '100%',
  backgroundColor: '#FFFFFF',
  borderRadius: '16px 16px 0 0',
  boxShadow: '0 -8px 30px rgba(0, 0, 0, 0.12)',
  '.grabber': {
    display: 'flex',
    justifyContent: 'center',
    padding: '9px 0 3px',
    span: {
      display: 'block',
      width: 38,
      height: 4,
      borderRadius: 2,
      backgroundColor: '#DDDDDD',
    },
  },
  '.title': {
    height: 50,
    padding: '0 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #EEEEEE',
    fontSize: 16,
    fontWeight: 500,
    color: '#333333',
  },
  ul: {
    padding: '4px 0',
  },
  button: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '15px 16px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    '&.selected': {
      backgroundColor: '#FFFBF3',
      '.label': { fontWeight: 500 },
      '.radio': { borderColor: '#F2A40B' },
    },
  },
  '.label': {
    fontSize: 16,
    color: '#333333',
  },
  '.radio': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 22,
    height: 22,
    borderRadius: '50%',
    border: '1.5px solid #CCCCCC',
    backgroundColor: '#FFFFFF',
    flexShrink: 0,
  },
  '.dot': {
    display: 'block',
    width: 11,
    height: 11,
    borderRadius: '50%',
    backgroundColor: '#F2A40B',
  },
})
